import React, { FC, memo, useMemo } from 'react'

import { useQuery } from '@apollo/client'
import { Select } from 'antd'
import { useFormContext, Controller } from 'react-hook-form'

import { GET_COUNTRIES } from 'Const'
import { Country } from 'Types'

interface Props {
  className?: string
  id?: string
  name: string
}

interface Data {
  countries: Country[]
}

const CountrySelect: FC<Props> = ({ name, className, ...props }) => {
  const { data } = useQuery<Data>(GET_COUNTRIES)
  const { control } = useFormContext()

  const options = useMemo(
    () =>
      data?.countries.map((country) => ({
        value: country.isoCode,
        label: country.name,
      })) || [],
    [data?.countries],
  )

  return (
    <Controller
      as={
        <Select
          showSearch
          className={`w-100 ${className}`}
          optionFilterProp="label"
          options={options}
          placeholder="Select your country"
          size="large"
          {...props}
        />
      }
      control={control}
      name={name}
    />
  )
}

export default memo(CountrySelect)
